import { Helmet } from "react-helmet-async";
import Screen from "../Layouts/Screen/Screen";
import ItemList from "../../components/ItemList/ItemList";
import { Archive, Award, Bell, DollarSign, FileText, Star, UserMinus, Users, UserX } from "react-feather";
import { Accessibility, Filter, PersonStanding, Search } from "lucide-react";
import { useCallback, useEffect, useRef, useState } from "react";
import { useMessage } from "../../global-components/src";
import axios from "axios";
import { useAuth } from "../../global-components/src";
import { errorMessage } from "../../utils/TextManagerTwo";
import Spinner from "../../global-components/src/components/spinner/spiner";
import { Ban } from "../../types";
import UserSearch from "../Settings/SearchScreen/User/User";
import { PACOCA_API_URL } from "../../global-components/src/utils/vars";
import { UserSearchLoadin } from "../Settings/SearchScreen/User/UserSearchLoading";
import { PostLoading } from "../../components/Post/post-loading";
import { Stamp, User } from "../../global-components/src/types";
import i18n from "../../global-components/src/i18n";
import { useSearchParams } from "react-router";
import debounce from 'lodash/debounce';

const UsersWithBadges = () => {
    const endOfListRef = useRef<HTMLDivElement | null>(null);
    const [bans, setBans] = useState<User[] | null>(null);
    const [listFilter, setListFilter] = useState<Stamp[]>([]);
    const { setMessage } = useMessage();
    const [loading, setLoading] = useState(false);
    const [end, setEnd] = useState(false);
    const [page, setPage] = useState(1);
    const { token } = useAuth();
    const [searchParams, setSearchParams] = useSearchParams();
    const [termo, setTermo] = useState(searchParams.get("termo") || "");
    const [showFilter, setShowFilter] = useState(false);
    const [termoSearch, setTermoSearch] = useState(termo);

    const loadData = async (listFilterParam: Stamp[] = listFilter, newPage: number = page) => {
        // const currentPage = newPage ?? page + 1; // Usa newPage se fornecido, senão incrementa
        let text = encodeURIComponent(termoSearch);
        const url = PACOCA_API_URL + `/moderators/user?page=${newPage}&search=${text}&filters=${listFilterParam?.join(",")}`;

        if (loading || end) return;
        setLoading(true);

        try {
            const response = await axios.get(url, {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "Authorization": `Bearer ${token}`
                }
            });

            const data = response.data;

            if (data.users.length > 0) {
                setBans((prevData) => [...(prevData || []), ...data.users]);
            } else {
                setEnd(true);
            }

        } catch (err: any) {
            const type = err?.response?.data?.type_message || "error";
            const messageError = errorMessage(err)
            setMessage(messageError, type)
            console.error('Erro:', err);
        } finally {
            setLoading(false);
        }
    };


    const debouncedHandleInput = useCallback(debounce(setTermoSearch, 500), [termo]);
    // useEffect(() => {
    //     loadData();
    // }, [termoSearch]);

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const input = event.target;
        const cursorPos = input.selectionStart || 0; // salva posição
        const inputValue = input.value;
        setTermo(inputValue);
        debouncedHandleInput(inputValue);

        const newParams = new URLSearchParams(searchParams);
        newParams.set("termo", inputValue);
        setSearchParams(newParams, { replace: true });

        setTimeout(() => {
            input.setSelectionRange(cursorPos, cursorPos);
        }, 0);
    };

    useEffect(() => {
        if(!loading && !end) loadData(listFilter, page);
    }, [page]);

    useEffect(() => {
        setBans(null);
        setEnd(false);
        setPage(1);
        loadData(listFilter, 1);
    }, [termoSearch]);
    
    useEffect(() => {
        const modalBody = document.getElementById("modal-comments-body");

        const handleScroll = () => {
            if (!modalBody) return;
            const { scrollTop, clientHeight, scrollHeight } = modalBody;

            if ((scrollTop + clientHeight >= scrollHeight - 50) && !end && !loading) {
                setPage((prevPage) => prevPage + 1); // Agora a página é atualizada antes da requisição
            }
        };

        if (modalBody) {
            modalBody.addEventListener("scroll", handleScroll);
            window.addEventListener("scroll", handleScroll);
        }

        return () => {
            if (modalBody) {
                modalBody.removeEventListener("scroll", handleScroll);
                window.removeEventListener("scroll", handleScroll);
            }
        };
    }, [end, loading]);
    
    const changeSelected = (type: Stamp) => {
        setBans(null);
        setEnd(false);
        setPage(1);

        const newValue = listFilter.includes(type)
            ? listFilter.filter((item) => item !== type)
            : [...listFilter, type];

        setListFilter(newValue);
        loadData(newValue, 1);
    };

    
    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === "Enter") {
            loadData(listFilter, 1)
        }
    };

    return (
        <>
            <Screen className="container-screen-search screen-search" title="Usuários com selos">
                <Helmet>
                    <title>Paçoca - Usuários com selos</title>
                </Helmet>


                <div className="d-flex container-search container-search-padding">
                    <input
                        id="input-search-screen"
                        className="form-control input-search input-search-screen"
                        type="text"
                        name="search"
                        placeholder={i18n.t("generics.search")}
                        aria-label="Search"
                        value={termo}
                        onChange={handleChange}
                        onKeyDown={handleKeyDown}
                        required
                    />
                    <button onClick={() => { setShowFilter(!showFilter) } } className="btn-search btn-search-screen input-search-screen-icon-menu-dark btn" type="button" title="Buscar">
                        <Filter color="#d3d3d3" />
                    </button>
                </div>

                <div className="row row row-fillter-search-badges" style={{ height: showFilter ? "auto" : "0", overflow: "hidden", transition: "height 0.3s ease" }}>
                    <button className={`btn col-notification btn-light all ${listFilter?.includes("blue") ? "notification-type-active" : ""}`} onClick={() => changeSelected("blue")}>
                        <p>{i18n.t("meaningSeals.verified.title")}</p>
                    </button>
                    
                    <button className={`btn col-notification btn-light mention ${listFilter?.includes("brown") ? "notification-type-active" : ""}`} onClick={() => changeSelected("brown")}>
                        <p>{i18n.t("meaningSeals.brown.title")}</p>
                    </button>

                    <button className={`btn col-notification btn-light mention ${listFilter?.includes("darkBlue") ? "notification-type-active" : ""}`} onClick={() => changeSelected("darkBlue")}>
                        <p>{i18n.t("meaningSeals.darkBlue.title")}</p>
                    </button>

                    <button className={`btn col-notification btn-light mention ${listFilter?.includes("red") ? "notification-type-active" : ""}`} onClick={() => changeSelected("red")}>
                        <p>{i18n.t("meaningSeals.red.title")}</p>
                    </button>

                    <button className={`btn col-notification btn-light mention ${listFilter?.includes("peach") ? "notification-type-active" : ""}`} onClick={() => changeSelected("peach")}>
                        <p>{i18n.t("meaningSeals.peach.title")}</p>
                    </button>

                    <button className={`btn col-notification btn-light comment ${listFilter?.includes("purple") ? "notification-type-active" : ""}`} onClick={() => changeSelected("purple")}>
                        <p>{i18n.t("meaningSeals.purple.title")}</p>
                    </button>

                    <button className={`btn col-notification btn-light comment ${listFilter?.includes("yellow") ? "notification-type-active" : ""}`} onClick={() => changeSelected("yellow")}>
                        <p>{i18n.t("meaningSeals.yellow.title")}</p>
                    </button>

                    <button className={`btn col-notification btn-light comment ${listFilter?.includes("black") ? "notification-type-active" : ""}`} onClick={() => changeSelected("black")}>
                        <p>{i18n.t("meaningSeals.black.title")}</p>
                    </button>

                    <button className={`btn col-notification btn-light comment ${listFilter?.includes("gray") ? "notification-type-active" : ""}`} onClick={() => changeSelected("gray")}>
                        <p>{i18n.t("meaningSeals.gray.title")}</p>
                    </button>
                </div>

                <>
                    {bans?.map((ban, index) => {
                        return (
                            <UserSearch clasImgAccount="img-list-chat" hideFollowUser key={index} user={ban} />
                        );
                    })}

                    <UserSearchLoadin loading={loading}/>

                    {(!bans && !loading) || (bans && !bans.length && !loading) ? (
                        <div className="user-select-none row mt-5">
                            <span className="span-empty">
                                <UserMinus className="icon-empty" />
                                <h3 className="w-100 text-center">Nenhuma usuário com selo</h3>
                            </span>
                        </div>
                    ): null}
                    
                    <p ref={endOfListRef}></p>
                </>
            </Screen>
        </>
    );
};

export default UsersWithBadges;